<template>
	<section id="disbursement-information" class="disbursement-information">
		<bg-grid>
			<bg-grid-item :col="12">
				<bg-card>
					<div class="section-title-with-button mb-16">
						<bg-text size="heading-5">
							Informasi Transfer Pendapatan
						</bg-text>
						<router-link
							v-if="accessEditInformasiTransferPendapatan"
							:to="editRoute"
						>
							<bg-button>Ubah</bg-button>
						</router-link>
					</div>

					<alert-countdown
						v-if="!!periodChangeInfo"
						:description="periodChangeInfo"
						class="bg-u-mb-xl width-fit-content"
						data-testid="disbursementInfo-alertCountdown"
					/>

					<bg-divider />

					<bg-grid v-if="loading" class="mt-24">
						<bg-grid-item v-for="i in 4" :cols="3" :key="i">
							<bg-skeleton width="60%" height="20px" />
						</bg-grid-item>
					</bg-grid>

					<template v-else>
						<bg-grid class="mt-24">
							<bg-grid-item :col="3">
								<bg-list-item title="Nomor Rekening">
									{{ disbursement.bank_account_number }}
								</bg-list-item>
							</bg-grid-item>

							<bg-grid-item :col="3">
								<bg-list-item title="Nama Bank">
									{{ disbursement.bank_name }}
								</bg-list-item>
							</bg-grid-item>

							<bg-grid-item :col="3">
								<bg-list-item title="Cabang Bank">
									{{ disbursement.bank_account_city }}
								</bg-list-item>
							</bg-grid-item>

							<bg-grid-item :col="3">
								<bg-list-item title="Nama Pemilik Rekening">
									{{ disbursement.bank_account_owner }}
								</bg-list-item>
							</bg-grid-item>
						</bg-grid>

						<bg-grid>
							<bg-grid-item :col="3" class="mb-0">
								<bg-list-item
									title="Tipe Transfer Pendapatan"
								>
									{{ period.label || '-' }}
								</bg-list-item>
							</bg-grid-item>

							<bg-grid-item :col="3" class="mb-0">
								<bg-list-item
									title="Tanggal Transfer Pendapatan"
								>
									<span
										v-if="period.val === 'monthly'"
									>
										{{ currentMonthTransferAndCutOffDates }}
									</span>

									<ul
										v-else-if="period.val === 'weekly'"
										class="list-style-disc bg-u-ml-lg"
									>
										<li
											v-for="(dates, i) in weeklyDates"
											:key="i"
										>
											{{ dates }}
										</li>
									</ul>

									<span v-else>-</span>
								</bg-list-item>
							</bg-grid-item>
						</bg-grid>
					</template>
				</bg-card>
			</bg-grid-item>
		</bg-grid>
	</section>
</template>

<script>
import {
	BgGrid,
	BgGridItem,
	BgCard,
	BgText,
	BgDivider,
	BgListItem,
	BgSkeleton,
	BgButton
} from 'bangul-vue';

import {
	dateFormatterToDisplay,
} from 'Utils/formatter';

import DISBURSEMENT_PERIOD_TYPES from '@admin/pages/PaymentDisbursementApproval/constants/disbursement-period-types';
import TRANSFER_DATE_OPTIONS from '@admin/pages/PaymentDisbursementApproval/constants/transfer-date-options';

import AlertCountdown from '@/components/molecules/AlertCountdown/AlertCountdown.vue';

export default {
	name: 'DisbursementInformation',

	components: {
		BgText,
		BgGrid,
		BgGridItem,
		BgCard,
		BgDivider,
		BgListItem,
		BgSkeleton,
		BgButton,
		AlertCountdown
	},

	props: {
		loading: {
			type: Boolean,
			default: false,
		},
		disbursement: {
			type: Object,
			default: () => ({}),
		},
	},

	computed: {
		accessEditInformasiTransferPendapatan() {
			return this.$store.getters.xCheckUserPermission('edit-informasi-transfer-pendapatan');
		},
		propertyId() {
			return this.$route.params.propertyId;
		},
		editRoute() {
			return {
				name: 'edit.disbursement-information',
				params: {
					propertyId: this.propertyId,
				},
			};
		},
		period() {
			const { disbursement_period: periodKey = '' } = this.disbursement;

			return DISBURSEMENT_PERIOD_TYPES[periodKey] || {};
		},
		currentMonthTransferAndCutOffDates() {
			const {
				transfer_date: transferDate,
				cutoff_period_start,
				cutoff_period_end
			} = this.disbursement;

			const cutOffStartDate = dateFormatterToDisplay(
				cutoff_period_start, 'D'
			);

			let cutOffEndDate = dateFormatterToDisplay(
				cutoff_period_end, 'D'
			);

			// Custom general end of month date label
			cutOffEndDate = cutOffEndDate >= 28 ? '30/31' : cutOffEndDate;

			const cutoffDate = `Cut Off: ${cutOffStartDate}-${cutOffEndDate}`;

			return `${transferDate} (${cutoffDate})`;
		},
		weeklyDates() {
			return TRANSFER_DATE_OPTIONS.weekly.map(
				date => date.label.replace(/Tanggal\s*/, '')
			);
		},
		periodChangeInfo() {
			const {
				next_disbursement_period: nextPeriodType = null,
				disbursement_period_changed_at: periodChangedAt = null
			} = this.disbursement;

			if (!nextPeriodType || !periodChangedAt) {
				return '';
			}

			const nextPeriodTypeLabel = DISBURSEMENT_PERIOD_TYPES[
				nextPeriodType
			]?.label || '';

			const periodChangedAtLabel = dateFormatterToDisplay(
				periodChangedAt,
				'DD MMMM YYYY'
			);

			return `Tipe transfer pendapatan diubah ke ${nextPeriodTypeLabel} mulai ${periodChangedAtLabel} (periode transfer berikutnya).`;
		}
	},

	methods: {
		handleEdit() {
			this.$emit('emit-edit');
		}
	}
};
</script>
